import { ApiResponse, ApiTyped } from 'data-source/types.wp'
import { DSHomePage, DSResource } from 'shared-definitions/types'

interface CodecGetHomePageOpts<T extends ApiTyped, A extends DSResource> {
  pagePath: string
  metaTitle: string
  metaDescription: string
  contentBlockMapper: (input: T) => A | A[]
}

export function codecGetHomePage<T extends ApiTyped, A extends DSResource>(
  raw: ApiResponse<T[]>,
  opts: CodecGetHomePageOpts<T, A>
): DSHomePage<A> {
  const input = raw.data
  const mappedArray = input.flatMap(opts.contentBlockMapper)
  const blocks: A[] = []
  for (const item of mappedArray) {
    if (item) {
      blocks.push(item)
    }
  }
  return {
    blocks,
    resource: 'home-page',
    sections: null,
    ampPagePath: null,
    meta: {
      engagementContainerId: null,
      disabledAds: false,
      dataLayer: null,
      subscribeTags: ['Home'],
      postId: null,
      sponsor: null,
      topics: [],
      sponsored: false,
      tags: [],
      categories: [],
    },
    head: {
      metaTitle: opts.metaTitle,
      metaTags: [
        {
          name: 'description',
          content: opts.metaDescription,
        },
      ],
      jsonLd: [],
    },
    pagePath: opts.pagePath,
  }
}
